import { FC } from 'react';
import { ReactComponent as EnvelopeIcon } from '../../../icons/envelope.svg';
import { ReactComponent as PhoneIcon } from '../../../icons/phone.svg';
import { ReactComponent as GlobeIcon } from '../../../icons/globe.svg';
import { ReactComponent as LocationIcon } from '../../../icons/location.svg';

interface InfoItemProps {
  icon: string;
  value: string;
  label: string;
  isMobile: boolean;
  iconCircleStyle: React.CSSProperties;
}

const getIconComponent = (icon: string) => {
  switch (icon) {
    case 'bi-envelope-fill':
      return <EnvelopeIcon />;
    case 'bi-telephone-fill':
      return <PhoneIcon />;
    case 'bi-globe':
      return <GlobeIcon />;
    case 'bi-geo-alt-fill':
      return <LocationIcon />;
    default:
      return null;
  }
};

export const InfoItem: FC<InfoItemProps> = ({ icon, value, label, isMobile, iconCircleStyle }) => {
  return (
    <div className="info-item d-flex align-items-center mb-6">
      <div
        className={`icon-circle ${isMobile ? 'icon-circle-mobile' : ''}`}
        style={iconCircleStyle}
      >
        <span className="text-white">{getIconComponent(icon)}</span>
      </div>
      <div className="ms-3 info-content">
        <div className="fw-semibold text-dark small text-content fs-3">
          {value}
        </div>
        <div className="text-muted small fs-4">{label}</div>
      </div>
    </div>
  );
};
